import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-log-plataforma',
  templateUrl: './log-plataforma.component.html',
  styleUrls: ['./log-plataforma.component.scss']
})
export class LogPlataformaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
